module.exports = __webpack_public_path__ + "static/media/zippyclip-logo.545779f9.jpg";